import { render, staticRenderFns } from "./PlateHGSClassificationCreateOrUpdate.vue?vue&type=template&id=71ed665a&"
import script from "./PlateHGSClassificationCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./PlateHGSClassificationCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports